import React, { createContext, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import server from '../../../global/server';

const AuthContext = createContext({});

export const AuthProvider = props => {
    const navigation = useNavigate();

    const [token, setToken] = useState();
    const [user, setUser] = useState({});

    const verifySession = async () => {
        const token = localStorage.getItem('token');

        if (token) {
            const sessionUser = localStorage.getItem('user');
            server.defaults.headers['Authorization'] = `Bearer ${token}`;
            setToken(token);
            const user = JSON.parse(sessionUser);
            setUser(user);
            
            // if (user.admin) {
            //     navigation('/dashboard');
            // } else {
            //     navigation('/profile');
            // }
            
        } else {
            delete server.defaults.headers.Authorization;
            setToken();
            //navigation('/login')
        }
    };

    useEffect(() => {
        verifySession();
    }, []);

    const LogOut = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        verifySession();
    };

    return <AuthContext.Provider value={{ logged: Boolean(token), user, LogOut, verifySession, setUser }}>{props.children}</AuthContext.Provider>;
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) throw 'Use Auth Context inside Auth Provider';

    return context;
};
